import { cn } from "@babybjorn/ui";
import { useState, type FC, type HTMLAttributes } from "react";
import * as s from "./ToggleButton.module.scss";

export type Option = 0 | 1;

type ToggleButtonProps = {
	active: Option;
	onToggle: (option: Option) => void;
	toggleLabels: [string, string];
	alwaysSmall?: boolean;
} & HTMLAttributes<HTMLButtonElement>;

const ToggleButton: FC<ToggleButtonProps> = (props) => {
	const [active, setActive] = useState(props.active);

	const onToggleWrapper = (option: Option) => () => {
		setActive(option);
		props.onToggle(option);
	};

	return (
		<fieldset className={s.toggle}>
			<button
				className={cn(s.button, s.left, {
					[s.active]: active === 0,
					[s.alwaysSmall]: props.alwaysSmall,
				})}
				onClick={onToggleWrapper(0)}
			>
				{props.toggleLabels[0]}
			</button>
			<button
				className={cn(s.button, s.right, {
					[s.active]: active === 1,
					[s.alwaysSmall]: props.alwaysSmall,
				})}
				onClick={onToggleWrapper(1)}
			>
				{props.toggleLabels[1]}
			</button>
		</fieldset>
	);
};

export default ToggleButton;
